import InputAdornment from '@mui/material/InputAdornment';
import { formatWeightValueForDisplay } from '@src/common/components/FormatWeightValueForDisplay';
import { TextInput } from '@src/common/components/TextInput';
import { useMeasurement } from '@src/common/measurements/useMeasurement';
import { type ComponentProps, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface Props extends Omit<ComponentProps<typeof TextInput>, 'value'> {
  value: number | null;
}

export const ReadonlyWeightInput = ({ value, label, ...props }: Props) => {
  const { t } = useTranslation();
  const { isMetric } = useMeasurement();

  const toDisplay = useCallback(
    (numberValue: number | undefined | null) => {
      return formatWeightValueForDisplay(numberValue, isMetric);
    },
    [isMetric],
  );

  return (
    <TextInput
      slotProps={{
        input: {
          readOnly: true,
          startAdornment: (
            <InputAdornment position="start">
              {isMetric ? t('units.kilos') : t('units.pounds')}
            </InputAdornment>
          ),
        },
      }}
      label={label}
      value={toDisplay(value)}
      readOnly={true}
      {...props}
    />
  );
};
